export default {
  menu: '',
  menu_active: false,
  currency_active: false,
  search_active: false,
  images: {}
}